import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { CircularProgress } from '@material-ui/core'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleUp } from '@fortawesome/pro-regular-svg-icons';

import { currentHttpOptions } from '../../../../../common/utilities/utilitiesFunctions';
import * as aux from '../../../../auxilaries';
import { updateSpinnerShow, updateSnackbar } from '../../actions';
import { getIsAsyncTaskProcessing } from '../WorkPlan.service';
import { CustomToolTip } from '../../../../../common/components/UI/';
import './ReloadCoverageButton.scss';

class ReloadCoverageButton extends Component {

	handleReloadCoverage = async () => {
		const { selectedWorkPlan, getWorkplanDetails, updateSnackbar } = this.props;
		try {
			await axios.post(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/workplan/${selectedWorkPlan.workplanId}/ReloadCoverage`, {}, currentHttpOptions())
			getWorkplanDetails();
		} catch (ex) {
			let errorMessage = aux.handleAPIErrors(ex.response)
			updateSnackbar({
				typeSnackbar: 'error',
				messageSnackbar: errorMessage,
				openSnackbar: true,
			})
			return Promise.reject(new Error(errorMessage)); // break out if this fails
		}
	};

    render() {
		const { t, selectedWorkPlan, disableToolbar } = this.props;
		const isAsyncTaskProcessing = getIsAsyncTaskProcessing(selectedWorkPlan);

        return (
            <CustomToolTip
                key="reload-coverage-tooltip"
                enterDelay={500}
                placement="right-start"
                leaveDelay={500}
                titletext={t('workPlanView.table.reloadCoverage')}
                jsx={
                    <div
                        className={`reload-coverage-button${(disableToolbar || isAsyncTaskProcessing) ? ' disabled' : '' }`}
                        onClick={(e) => {
                            !isAsyncTaskProcessing && this.handleReloadCoverage();
                            e.stopPropagation();
                        }}
                    >
                        {
                            selectedWorkPlan.isReloadingCoverage
                                ? <CircularProgress size={20}/>
                                : <FontAwesomeIcon icon={faArrowCircleUp} />
                        }
                    </div>
                }
            />
        );
    }
}

const mapStateToProps = state => {
	return {
		spinnerShow: state.spinnerShow,
		selectedWorkPlan: state.selectedWorkPlan,
		snackbar: state.snackbar
	}
}

const mapDispatchToProps = {
	updateSpinnerShow,
    updateSnackbar
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(ReloadCoverageButton));
